// @flow
import { makeApiCall } from '../../../../services/apiService/apiService';
import { toastr } from 'react-redux-toastr';

export const collectionsHandoverActions = {
  SET_COLLECTIONS_HANDOVER_DATE_FILTER: 'SET_COLLECTIONS_HANDOVER_DATE_FILTER',
  GET_COLLECTIONS_HANDOVER: 'GET_COLLECTIONS_HANDOVER',
  FILTER_COLLECTIONS_HANDOVER_TABLE_DATA:
    'FILTER_COLLECTIONS_HANDOVER_TABLE_DATA',
  GET_COLLECTIONS_HANDOVER_DATE_WISE: 'GET_COLLECTIONS_HANDOVER_DATE_WISE',
  GET_CN_WISE_HANDOVER_DETAILS: 'GET_CN_WISE_HANDOVER_DETAILS',
  INITIATE_HANDOVER: 'INITIATE_HANDOVER',
  INITIATE_PAY_NEAR_HANDOVER: 'INITIATE_PAY_NEAR_HANDOVER',
  DOWNLOAD_TEMPLATE: 'DOWNLOAD_TEMPLATE',
  INITIATE_WRITE_OFF: 'INITIATE_WRITE_OFF'
};

export const setDateFilter = (startDate = false, endDate = false) => ({
  type: collectionsHandoverActions.SET_COLLECTIONS_HANDOVER_DATE_FILTER,
  payload: { startDate, endDate }
});

export const filterTableData = (val: string) => ({
  type: collectionsHandoverActions.FILTER_COLLECTIONS_HANDOVER_TABLE_DATA,
  payload: val
});

export const getCollectionsHandoverAction = (obj: Object) => ({
  type: collectionsHandoverActions.GET_COLLECTIONS_HANDOVER,
  payload: obj
});

export const getCollectionsHandover = () => (dispatch: Function) => {
  dispatch(
    getCollectionsHandoverAction({
      isLoading: true,
      isLoaded: false,
      tableData: null,
      tableDataFiltered: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getCollectionsHandover',
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('Fetched collections handover ', res);
      if (res.status === 'SUCCESS') {
        const data = {
          isLoading: false,
          isLoaded: true,
          tableData: res.payload,
          tableDataFiltered: res.payload
        };
        dispatch(getCollectionsHandoverAction(data));
      } else if (res.status === 'FAILURE') {
        dispatch(
          getCollectionsHandoverAction({
            isLoading: false,
            isLoaded: true,
            tableData: [],
            tableDataFiltered: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Failure in fetching collections handover, res= ', res);
      dispatch(
        getCollectionsHandoverAction({
          isLoading: false,
          isLoaded: true,
          tableData: [],
          tableDataFiltered: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in fetching collections handover', res);
      dispatch(
        getCollectionsHandoverAction({
          isLoading: false,
          isLoaded: true,
          tableData: [],
          tableDataFiltered: []
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const initiateHandoverAction = (obj: Object) => ({
  type: collectionsHandoverActions.INITIATE_HANDOVER,
  payload: obj
});

export const uploadHandoverFileAction = (obj: Object) => ({
  type: collectionsHandoverActions.INITIATE_PAY_NEAR_HANDOVER,
  payload: obj
});

export const downloadTemplate = (obj: Object) => ({
  type: collectionsHandoverActions.DOWNLOAD_TEMPLATE,
  payload: obj
});

export const getCnWiseHandoverDetailsAction = (obj: Object) => ({
  type: collectionsHandoverActions.GET_CN_WISE_HANDOVER_DETAILS,
  payload: obj
});

export const resetHandoverProp = () => dispatch => {
  dispatch(
    initiateHandoverAction({
      handover: {
        callInitiated: false,
        callCompleted: null,
        callSuccess: null,
        error: null
      }
    })
  );
};

// const dummyPrintData = {
//   handOverFrom: "Chirag Parihar",
//   handoverTo: "test_pce_stg",
//   location: "Delhi",
//   dateTime: "2018-02-05T07:16:26.246Z",
//   totalCNs: 1,
//   totalCash: 0,
//   totalCheque: 200,
//   totalAmount: 200,
//   consignmentHandoverDTOList: [
//     {
//       cnote: "3231233123",
//       consignmentId: 1015023,
//       clientUserName: "9900094131",
//       clientUserMobile: "TECHMASH SOLUTIONS PVT. LTD.",
//       paymentMode: "PREPAID",
//       paymentType: "Cash",
//       bankName: null,
//       chequeNumber: null,
//       amount: 200,
//       collectionTime: 1517810642117,
//       completionStatus: "COMPLETE"
//     }
//   ]
// };

export const initiateHandover = (handoverData: Object) => (
  dispatch: Function
) => {
  dispatch(
    initiateHandoverAction({
      handover: {
        callInitiated: true,
        callCompleted: false,
        callSuccess: false,
        error: null,
        printData: null
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'initiateHandover',
    data: handoverData,
    method: 'POST',
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('Handover initiate call returns 200 ', res);
      if (res.status === 'SUCCESS') {
        dispatch(
          initiateHandoverAction({
            handover: {
              callInitiated: true,
              callCompleted: true,
              callSuccess: true,
              error: null,
              printData: res.payload
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          initiateHandoverAction({
            handover: {
              callInitiated: true,
              callCompleted: true,
              callSuccess: false,
              error: res.errorMessage,
              printData: null
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Handover inititation call failed ', res);
      dispatch(
        initiateHandoverAction({
          handover: {
            callInitiated: true,
            callCompleted: true,
            callSuccess: false,
            error: null,
            printData: null
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in initiate handover call', res);
      dispatch(
        initiateHandoverAction({
          handover: {
            callInitiated: true,
            callSuccess: false,
            callCompleted: true,
            error: null,
            printData: null
          }
          // success obj, delete it
          // handover: {
          //   callInitiated: true,
          //   callCompleted: true,
          //   callSuccess: true,
          //   error: null,
          //   printData: dummyPrintData
          // }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const uploadHandoverFile = formData => (dispatch: Function) => {
  dispatch(
    initiateHandoverAction({
      payNearHandover: {
        callInitiated: true,
        callCompleted: false,
        callSuccess: false,
        error: null
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'uploadHandoverFile',
    postFormData: true,
    data: formData,
    method: 'POST',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          uploadHandoverFileAction({
            payNearHandover: {
              callInitiated: true,
              callCompleted: true,
              callSuccess: true,
              error: null
            }
          })
        );
        toastr.success('Success', res.payload);
      } else if (res.status === 'FAILURE') {
        dispatch(
          uploadHandoverFileAction({
            payNearHandover: {
              callInitiated: true,
              callCompleted: true,
              callSuccess: false,
              error: res.errorMessage,
              printData: null
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Handover inititation call failed ', res);
      dispatch(
        uploadHandoverFileAction({
          payNearHandover: {
            callInitiated: true,
            callCompleted: true,
            callSuccess: false,
            error: null,
            printData: null
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in initiate handover call', res);
      dispatch(
        uploadHandoverFileAction({
          payNearHandover: {
            callInitiated: true,
            callSuccess: false,
            callCompleted: true,
            error: null,
            printData: null
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const downloadCashHandoverTemplate = () => (dispatch: Function) => {
  dispatch(
    downloadTemplate({
      downloadingTemplate: true
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getHandoverFileTemplate',
    method: 'GET',
    responseType: 'arraybuffer',
    successCb: res => {
      const blob = new Blob([res], {
        type: 'text/csv'
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'pay_near_handover_sheet_template.csv';
      link.click();
      dispatch(
        downloadTemplate({
          downloading: false
        })
      );
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to downloadCashHandoverTemplate ', res);
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to download sample template.'
      );
      dispatch(
        downloadTemplate({
          downloading: false
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while downloadCashHandoverTemplate ', res);
      toastr.error(
        'Something went wrong!',
        'Unable to download sample template.'
      );
      dispatch(
        downloadTemplate({
          downloading: false
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getCnWiseHandoverDetails = params => (dispatch: Function) => {
  dispatch(
    getCnWiseHandoverDetailsAction({
      cnWiseHandoverData: {
        isLoading: true,
        isLoaded: false,
        tableData: null,
        tableDataFiltered: null
      }
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getCnWiseHandoverDetails',
    replaceParamsArr: [
      { key: 'fromDate', val: params.fromDate },
      { key: 'toDate', val: params.toDate },
      { key: 'userId', val: params.userId }
    ],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('Fetched CnWiseHandoverDetails ', res);
      if (res.status === 'SUCCESS') {
        dispatch(
          getCnWiseHandoverDetailsAction({
            cnWiseHandoverData: {
              isLoading: false,
              isLoaded: true,
              tableData: res.payload,
              tableDataFiltered: res.payload
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getCnWiseHandoverDetailsAction({
            cnWiseHandoverData: {
              isLoading: false,
              isLoaded: true,
              tableData: null,
              tableDataFiltered: null
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Failure in fetching CnWiseHandoverDetails, res= ', res);
      dispatch(
        getCnWiseHandoverDetailsAction({
          isLoading: false,
          isLoaded: true,
          tableData: null,
          tableDataFiltered: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in fetching getCnWiseHandoverDetails', res);
      dispatch(
        getCnWiseHandoverDetailsAction({
          isLoading: false,
          isLoaded: true,
          tableData: null,
          tableDataFiltered: null
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const initiateWriteOffAction = (obj: Object) => ({
  type: collectionsHandoverActions.INITIATE_WRITE_OFF,
  payload: obj
});

export const initiateWriteOff = (writeOffData: Object) => (
  dispatch: Function
) => {
  dispatch(
    initiateWriteOffAction({
      writeOff: {
        callInitiated: true,
        callCompleted: false,
        callSuccess: false,
        error: null,
        printData: null
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'initiateWriteOff',
    data: writeOffData,
    method: 'POST',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          initiateWriteOffAction({
            writeOff: {
              callInitiated: true,
              callCompleted: true,
              callSuccess: true,
              error: null,
              printData: res.payload
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          initiateWriteOffAction({
            writeOff: {
              callInitiated: true,
              callCompleted: true,
              callSuccess: false,
              error: res.errorMessage,
              printData: null
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' writeOff inititation call failed ', res);
      dispatch(
        initiateWriteOffAction({
          writeOff: {
            callInitiated: true,
            callCompleted: true,
            callSuccess: false,
            error: null,
            printData: null
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in initiate writeOff call', res);
      dispatch(
        initiateWriteOffAction({
          writeOff: {
            callInitiated: true,
            callSuccess: false,
            callCompleted: true,
            error: null,
            printData: null
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};
